import { render, staticRenderFns } from "./SectionSubHeader.vue?vue&type=template&id=a243b570&scoped=true&"
var script = {}
import style0 from "./SectionSubHeader.vue?vue&type=style&index=0&id=a243b570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a243b570",
  null
  
)

export default component.exports